import { STEEZYClassIcon } from "lib/components/Icon";

export const ClassIcon = STEEZYClassIcon;
export * from "./create";
export * from "./edit";
export * from "./list";
